<template>
    <v-container fluid v-if="activeProject">
        <v-card class="mb-3">
            <v-card-text>
                <div class="title">Bot {{activeProject.bot_name}} - {{$t('messageReactionDetails') | capitalizeAll}}</div>
                <v-layout align-center>
                    <span class="mr-3">
                        <v-autocomplete
                            v-model="messageSource"
                            :label="$filters.capitalize($t('supporter'))"
                            :items="messageSourceList"
                            clearable
                        ></v-autocomplete>
                    </span>
                    <span class="mr-3">
                        <v-autocomplete
                            v-model="channel"
                            :label="$filters.capitalize($t('channel'))"
                            :items="channelList"
                            clearable
                        ></v-autocomplete>
                    </span>
                    <span class="mr-3">
                        <v-autocomplete
                            v-model="isLike"
                            :label="$filters.capitalize($t('like') + '/' + $t('dislike'))"
                            :items="reactionList"
                            clearable
                        ></v-autocomplete>
                    </span>
                    <span class="mr-3">
                        <DatePicker
                            v-model="fromDate"
                            :label="$filters.capitalize($t('from'))"
                            :max="toDate"
                        ></DatePicker>
                    </span>
                    <span>
                        <DatePicker
                            v-model="toDate"
                            :label="$filters.capitalize($t('to'))"
                            :min="fromDate"
                            :max="today"
                        ></DatePicker>
                    </span>
                    <v-spacer></v-spacer>
                    <v-btn depressed color="#878787" dark @click="loadDataTable" class="text-capitalize">
                        <v-icon class="mr-1">mdi-sync</v-icon>
                        {{$t('update')}}
                    </v-btn>
                    <v-btn depressed color="#42BE80" dark @click="getAnswerReportExcel" class="text-capitalize">
                        <v-icon class="mr-1">mdi-file-excel</v-icon>
                        {{$t('exportReport')}}
                    </v-btn>
                </v-layout>
            </v-card-text>
        </v-card>
        <v-card>
            <SimpleDataTable
                :headers="headers"
                :items="dataTable"
                :pagination.sync="pagination"
            >
                <template v-slot:sender_name="props">
                    <v-layout align-center>
                        <img
                            :src="`${baseUrl}/img/channel_icon/${props.item.channel}.png`"
                            :alt="props.item.channel"
                            class="mr-1"
                            style="width: 20px;height: 20px;"/>
                        <span>{{props.item.sender_name}}</span>
                    </v-layout>
                </template>
                <template v-slot:is_like="props">
                    <v-layout align-center>
                        <span style="color: #42BE80" v-if="props.item.is_like">Like</span>
                        <span style="color: #F44A3F" v-else>Dislike</span>
                    </v-layout>
                </template>
            </SimpleDataTable>
        </v-card>
    </v-container>
</template>
<script>
import AgentDetails from '@/views/Agent/AgentDetails'
import SimpleDataTable from '@/components/SimpleDataTable'
import AnswerService from '@/services/answer.service'

export default {
    name: 'CustomerSatisfaction.vue',
    extends: AgentDetails,
    components: { SimpleDataTable },
    data () {
        return {
            isLike: '',
            messageSource: '',
            messageSourceList: [
                { text: 'Bot', value: 'bot' },
                { text: 'Agent', value: 'agent' }
            ],
            reactionList: [
                { text: this.$filters.capitalize(this.$t('like')), value: 'True' },
                { text: this.$filters.capitalize(this.$t('dislike')), value: 'False' }
            ],
            baseUrl: process.env.BASE_URL
        }
    },
    watch: {
        filter () {
            this.loadDataTable()
        }
    },
    computed: {
        headers () {
            return this.$appService.correctHeaders([
                {
                    text: this.$t('time'),
                    value: 'created',
                    $value: item => this.$filters.formatDateTime(item.created)
                },
                {
                    text: this.$t('user'),
                    value: 'sender_name',
                    type: 'custom',
                    id: 'sender_name'
                },
                {
                    text: this.$t('like') + '/' + this.$t('dislike'),
                    value: 'is_like',
                    type: 'custom',
                    id: 'is_like'
                },
                {
                    text: this.$t('message'),
                    value: 'message'
                },
                {
                    text: this.$t('supporter'),
                    value: 'message_source'
                }
            ])
        },
        filter () {
            return {
                messageSource: this.messageSource,
                channel: this.channel,
                isLike: this.isLike,
                fromDate: this.fromDate,
                toDate: this.toDate
            }
        }
    },
    methods: {
        getDataTablePromise () {
            return AnswerService.getAnswerReport(this.messageSource, this.channel, this.isLike, this.fromDate, this.toDate, this.pagination)
        },
        getAnswerReportExcel () {
            return AnswerService.getAnswerReportExcel(this.messageSource, this.channel, this.isLike, this.fromDate, this.toDate)
        }
    }
}
</script>

<style scoped>

</style>
